import { QGL_Lib } from "./QGL_Lib";

export class VURQGL_Lib extends QGL_Lib {

  async EjendommeVurderetUnderBFE(bfeNummer: string): Promise<any> {
    let BFEKrydsRef = await this.VUR_BFEKrydsReference(bfeNummer);
    if (BFEKrydsRef.VUR_BFEKrydsreference.nodes.length == 0) {
      throw new Error("No VUR_BFEKrydsreference found for BFE Nummer: " + bfeNummer);
    }
    let fkVurderingsejendomID = [BFEKrydsRef.VUR_BFEKrydsreference.nodes[0].fkEjendomsvurderingID];
    let Vurdering = this.EjendommeIVurdering(fkVurderingsejendomID);
    return (await Vurdering).VUR_BFEKrydsreference.nodes.map((a) => a.BFEnummer);
  }

  async VurdFromBFE(bfeNummer: string): Promise<any> {
    let BFEKrydsRef = await this.VUR_BFEKrydsReference(bfeNummer);
    if (BFEKrydsRef.VUR_BFEKrydsreference.nodes.length == 0) {
      throw new Error("No VUR_BFEKrydsreference found for BFE Nummer: " + bfeNummer);
    }
    let fkEjendomsvurderingID = BFEKrydsRef.VUR_BFEKrydsreference.nodes.map((a) => a.fkEjendomsvurderingID);
    return this.VUR_Ejendomsvurdering(fkEjendomsvurderingID);
  }

  async VUR_BFEKrydsReference(bfeNummer: string): Promise<{ VUR_BFEKrydsreference: { nodes: any[] } }> {
    let isoNow = new Date().toISOString();
    return this.query<{ VUR_BFEKrydsreference: { nodes: any[] } }>(`
{
   VUR_BFEKrydsreference(
     registreringstid: "${isoNow}"
     virkningstid: "${isoNow}"
     where: { BFEnummer: { eq: ${bfeNummer} } }
   ) {
     nodes {
       fkEjendomsvurderingID
     }
   }
 }`)
  }

  async VUR_Vurderingsejendom(vurderingsejendomID: string[]): Promise<{ VURD_BestemtFastEjendom: { nodes: any[] } }> {
    let isoNow = new Date().toISOString();
    return this.query<{ VURD_BestemtFastEjendom: { nodes: any[] } }>(`
{
   VUR_Vurderingsejendom(
     registreringstid: "${isoNow}"
     virkningstid: "${isoNow}"
     where: { vurderingsejendomID: { in: [${vurderingsejendomID.join(",")}] } }
   ) {
     nodes {
       datafordelerOpdateringstid
       datafordelerRegisterImportSequenceNumber
       datafordelerRowId
       datafordelerRowVersion
       ESRejendomsnummer
       ESRkommunenummer
       vurderingsejendomID
       VURejendomsid
     }
   }
}`)
  }

  async EjendommeIVurdering(fkVurderingsejendomID: string[]): Promise<{ VUR_BFEKrydsreference: { nodes: any[] } }> {
    let isoNow = new Date().toISOString();
    return this.query<{ VUR_BFEKrydsreference: { nodes: any[] } }>(`
{
   VUR_BFEKrydsreference(
     registreringstid: "${isoNow}"
     virkningstid: "${isoNow}"
     where: { fkEjendomsvurderingID: { in: [${fkVurderingsejendomID.join(",")}] }
      }
    ) {
      nodes {
        BFEnummer
    }
    }
    }`)

  }

  async VUR_Ejendomsvurdering(fkVurderingsejendomID: string[]): Promise<{ VURD_Ejendomsvurdering: { nodes: any[] } }> {
    let isoNow = new Date().toISOString();
    return this.query<{ VURD_Ejendomsvurdering: { nodes: any[] } }>(`
{
        VUR_Ejendomsvurdering(
          registreringstid: "${isoNow}"
     virkningstid: "${isoNow}"
     where: { id: { in: [${fkVurderingsejendomID.join(",")}]
      } }
   ) {
     nodes {
    aar
    aendringDato
    aendringKode
    ajourfoeringDato
    antalMedvurderedeLejligheder
    benyttelseKode
    daekningsafgiftForskelVaerdi
    daekningsafgiftPligtKode
    daekningsafgiftPligtTypeKode
    datafordelerOpdateringstid
    datafordelerRegisterImportSequenceNumber
    datafordelerRowId
    datafordelerRowVersion
    ejendomvaerdiBeloeb
    fkModerejendomID
    fkVurderetUnderID
    fkVurderingsejendomID
    grundvaerdiBeloeb
    id
    juridiskKategoriKode
    juridiskKategoriTekst
    juridiskUnderkategoriKode
    juridiskUnderkategoriTekst
    vurderetAreal
    vurderingskredsKode
    VURMark
    harFordelinger(first: 10) {
         nodes {
        datafordelerOpdateringstid
        datafordelerRegisterImportSequenceNumber
        datafordelerRowId
        datafordelerRowVersion
        ejerboliggrundvaerdi
        ejerboligvaerdi
        ejerboligvaerdiKode
        fkEjendomsvurderingID
        FordelingID
      }
    }
    harFritagelser(first: 10) {
         nodes {
        artKode
        beloeb
        datafordelerOpdateringstid
        datafordelerRegisterImportSequenceNumber
        datafordelerRowId
        datafordelerRowVersion
        ejendomTypeKode
        fkEjendomsvurderingID
        FritagelseID
        loebenummer
        omfangKode
      }
    }
       harLoftansaettelse {
      basisaar
      datafordelerOpdateringstid
      datafordelerRegisterImportSequenceNumber
      datafordelerRowId
      datafordelerRowVersion
      fkEjendomsvurderingID
      grundvaerdi
      LoftansaettelseID
      pgf11
         harLoftFradragForForbedring {
        datafordelerOpdateringstid
        datafordelerRegisterImportSequenceNumber
        datafordelerRowId
        datafordelerRowVersion
        fkLoftansaettelseID
        foersteGangAar
        LoftFradragForForbedringOverordnetID
        sammensaettesAf(first: 10) {
             nodes {
            aar
            datafordelerOpdateringstid
            datafordelerRegisterImportSequenceNumber
            datafordelerRowId
            datafordelerRowVersion
            fkLoftFradragForForbedringOverordnetID
            loebenummer
            LoftFradragForForbedringID
            vaerdi
          }
        }
      }
    }
    harStyringskodeKrydsreferencer(first: 10) {
         nodes {
        begrundelse
        datafordelerOpdateringstid
        datafordelerRegisterImportSequenceNumber
        datafordelerRowId
        datafordelerRowVersion
        fkEjendomsvurderingID
        kategoriTekst
        kode
        lovhenvisning
        overskrift
        StyringskodeKrydsreferenceID
        vurderingsmeddelelse
      }
    }
    harGrundvaerdispecifikationer(first: 10) {
         nodes {
        areal
        beloeb
        datafordelerOpdateringstid
        datafordelerRegisterImportSequenceNumber
        datafordelerRowId
        datafordelerRowVersion
        enhedBeloeb
        fkEjendomsvurderingID
        GrundvaerdispecifikationID
        loebenummer
        prisKode
        tekst
      }
    }
       harFradragForForbedring {
      datafordelerOpdateringstid
      datafordelerRegisterImportSequenceNumber
      datafordelerRowId
      datafordelerRowVersion
      fkEjendomsvurderingID
      foersteGangAar
      FradragForForbedringOverordnetID
      vaerdiSum
      sammensaettesAf(first: 10) {
           nodes {
          fkFradragForForbedringOverordnetID
          datafordelerOpdateringstid
          datafordelerRegisterImportSequenceNumber
          datafordelerRowId
          datafordelerRowVersion
          fkFradragForForbedringOverordnetID
          FradragForForbedringID
          loebenummer
          tekst
          vaerdi
        }
      }
    }
  }
}
 }`)
  }

}